var CATALOG = CATALOG || {
  data: {
    url: '',
    $body: document.getElementsByTagName('body')[0],
    $html: document.getElementsByTagName('html')[0],
    $window: window,
    $MQ: 'PC',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    transitonEnd:
      'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd'
  },
  common: {
    init: {}
  }
};



CATALOG.common = function (pageScript) {
  // コンストラクタ  =================================================================
  const init = (pageScript) => {
    setUtilityData();
    setBrowser();

    document.getElementsByClassName('js--anchorLink').length && initAnchorLink();
    // CATALOG.data.$window.addEventListener('load', checkAnchorLink);  // 別ページからのアンカーリンクがある場合の関数

    document.getElementsByClassName('js--inview').length && initInview();

    // CATALOG.data.$window.addEventListener('load', initHeader);

    document.querySelector('.page-top') && initPageTop();

    document.querySelector('.js--burger') && initHeaderBurger();

    document.querySelector('.js--category-btn') && initCategoryModal();

    pageScript && pageScript();
  }



  // public functions  ==========================================================
  /*
  *   UtilityDataの取得
  *   特定ページのみで使用するデータはページJSで取得すること。
  *
  */
  const setUtilityData = () => {
    CATALOG.data.url = window.location.pathname;

    getScrollTop();
    CATALOG.data.$window.addEventListener('scroll', getScrollTop);

    getWindowSize();
    CATALOG.data.$window.addEventListener('resize', getWindowSize);
  }
  const getScrollTop = () => {
    CATALOG.data.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  }


  const getWindowSize = () => {
    CATALOG.data.winW = document.documentElement.clientWidth;
    CATALOG.data.winH = document.documentElement.clientHeight;

    const mWidth = window.getComputedStyle(CATALOG.data.$body).getPropertyValue('min-width');

    switch (mWidth) {
      case '2px':
        CATALOG.data.$MQ = 'SP';
        break;
      case '768px':
        CATALOG.data.$MQ = 'TABLET';
        break;
      default:
        CATALOG.data.$MQ = 'PC';
    }

    if (CATALOG.data.oldMQ && CATALOG.data.oldMQ !== CATALOG.data.$MQ) {
      const event = new Event('onBreakpointChange');

      // Dispatch the event.
      CATALOG.data.$window.dispatchEvent(event);
    }

    CATALOG.data.oldMQ = CATALOG.data.$MQ;
  }
  // HO TO USE
  // CATALOG.data.$window.addEventListener('onBreakpointChange', 実行文);


  /*
  *
  *  ブラウザ判定
  *
  */
  const setBrowser = () => {
    CATALOG.data.ua = {
      Safari: typeof window.chrome == 'undefined' && 'WebkitAppearance' in document.documentElement.style,
      Firefox: 'MozAppearance' in document.documentElement.style,
      IE: window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1,
      IE9: window.navigator.appVersion.toLowerCase().indexOf('msie 9.') !== -1,
      ltIE9: typeof window.addEventListener === 'undefined' && typeof document.getElementsByClassName === 'undefined',
      Touch: typeof document.ontouchstart !== 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled,
      Windows: window.navigator.userAgent.toLowerCase().indexOf('win') !== -1,
      Mac: window.navigator.userAgent.toLowerCase().indexOf('mac') !== -1,
      Mobile: window.navigator.userAgent.toLowerCase().indexOf('iphone') > 0 || window.navigator.userAgent.toLowerCase().indexOf('ipod') > 0 || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') > 0,
      Tablet: window.navigator.userAgent.toLowerCase().indexOf('ipad') > 0 || (window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') == -1)
    };
    if (CATALOG.data.ua.Safari) {
      CATALOG.data.$html.classList.add('safari');
    }
    if (CATALOG.data.ua.Firefox) {
      CATALOG.data.$html.classList.add('firefox');
    }
    if (CATALOG.data.ua.IE) {
      CATALOG.data.$html.classList.add('ie');
    }
    if (CATALOG.data.ua.IE9) {
      CATALOG.data.$html.classList.add('ie9');
    }
    if (CATALOG.data.ua.ltIE9) {
      CATALOG.data.$html.classList.add('ie8');
    }
    if (CATALOG.data.ua.Tablet) {
      CATALOG.data.$html.classList.add('tablet');
    }

    /* Defining touch events */
    if (CATALOG.data.ua.Touch) {
      touchDeviceDirectionJudge();
      CATALOG.data.$window.addEventListener('orientationchange', touchDeviceDirectionJudge);
    }
  }

  const touchDeviceDirectionJudge = () => {
    if (Math.abs(window.orientation) !== 90) {
      CATALOG.data.$html.classList.remove('landscape');
      CATALOG.data.$html.classList.add('portrait');
    } else {
      CATALOG.data.$html.classList.remove('portrait');
      CATALOG.data.$html.classList.add('landscape');
    }
  }



  // event functions  =================================================================
  /*
  *
  *  アンカーリンク
  *
  */
  const $header = document.getElementById('js--header');

  const initAnchorLink = () => {
    const $anchorLink = document.getElementsByClassName('js--anchorLink'),
      $anchorLinks = Array.from($anchorLink);

    $anchorLinks.forEach(function (target) {
      target.addEventListener('click', anchorLinkClicked);
    });
  }

  const anchorLinkClicked = (e) => {
    const $clickedLink = e.currentTarget,
      href = $clickedLink.getAttribute('href'),
      target = href === '#' || href === '' ? CATALOG.data.$html : setSection(href),
      offset = target ? window.pageYOffset + target.getBoundingClientRect().top : '';

    if (target) {
      e.preventDefault();
      moveToSection(offset);
    }

    return false;
  }

  // 別ページからのアンカーリンク
  const checkAnchorLink = () => {
    const hash = window.location.hash;

    if (!hash) return;

    const target = setSection(hash),
      offset = target.offsetTop;

    moveToSection(offset);
  }

  const moveToSection = (offset) => {
    const headerHeight = $header.clientHeight;

    CATALOG.data.$window.scrollTo({
      top: offset - headerHeight,
      behavior: 'smooth'
    });

  }
  const setSection = (section) => {
    const index = section.indexOf('#'),
      target = section.slice(index + 1);

    return document.getElementById(target);
  }



  /*
  *
  *  Page Top
  *
  */
  const $pageTop = document.querySelector('.page-top');

  const initPageTop = () => {
    CATALOG.data.$body.addEventListener('click', (e) => {
      if (e.target.closest('.page-top')) {
        CATALOG.data.$window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    CATALOG.data.$window.addEventListener('scroll', updatePageTop, { passive: true });
    CATALOG.data.$window.addEventListener('resize', updatePageTop);
    updatePageTop();
  };

  const updatePageTop = () => {
    const $footer = document.querySelector('.footer');
    if (!$footer) return;

    const scrollTop = window.scrollY;
    const winH = window.innerHeight;
    const isSP = window.innerWidth <= 767;
    const footerTop = $footer.getBoundingClientRect().top + scrollTop;
    const btnH = $pageTop.offsetHeight; // 54px
    const btnBottom = isSP ? 16 : 24;
    const footerH = $footer.offsetHeight;

    // ファーストビュー内は非表示
    if (scrollTop < winH) {
      $pageTop.classList.remove('is-visible');
      $pageTop.style.position = '';
      $pageTop.style.bottom = '';
      return;
    }

    $pageTop.classList.add('is-visible');

    // fixed状態でのボタンtop位置（ページ座標）
    const btnTopFixed = scrollTop + winH - btnBottom - btnH;

    // ドック位置（ページ座標）
    const dockTop = isSP
      ? footerTop - btnH / 2  // SPはボタンの半分がフッター内
      : footerTop + 80;       // PCはフッター上部から80px

    if (btnTopFixed >= dockTop) {
      // footer内でabsolute固定
      // SP: bottom = footerH - btnH/2 → ボタン上半分がfooter外にはみ出す
      // PC: bottom = footerH - btnH - 80 → ボタンtopがfooter上部から80px
      const dockBottom = isSP
        ? footerH - btnH / 2
        : footerH - btnH - 80;
      $pageTop.style.position = 'absolute';
      $pageTop.style.bottom = dockBottom + 'px';
    } else {
      $pageTop.style.position = '';
      $pageTop.style.bottom = '';
    }
  };


  /*
  *
  *  initInview
  *
  */
  const initInview = () => {
    document.addEventListener('DOMContentLoaded', function () {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is--inview_on');

          } else {
            entry.target.classList.remove('is--inview_on');
          }
        });
      });

      document.querySelectorAll('.js--inview').forEach(item => {
        observer.observe(item);
      });
    });
  }


  /*
  *
  *  Header burger menu (SP)
  *
  */
  /*
  *
  *  Category Modal
  *
  */
  const initCategoryModal = () => {
    const $btn    = document.querySelector('.js--category-btn');
    const $modal  = document.getElementById('js--category-modal');

    if (!$btn || !$modal) return;

    const openModal = () => {
      $modal.classList.add('is-open');
      $btn.setAttribute('aria-expanded', 'true');
      $modal.setAttribute('aria-hidden', 'false');
    };

    const closeModal = () => {
      $modal.classList.remove('is-open');
      $btn.setAttribute('aria-expanded', 'false');
      $modal.setAttribute('aria-hidden', 'true');
    };

    $btn.addEventListener('click', () => {
      $modal.classList.contains('is-open') ? closeModal() : openModal();
    });

    document.querySelectorAll('.js--category-close').forEach(($el) => {
      $el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && $modal.classList.contains('is-open')) closeModal();
    });

    // 静的ページ: モーダル内にカテゴリがない場合はAJAXから取得して描画
    const $modalBody = $modal.querySelector('.header__cat-modal-body');
    if ($modalBody && !$modalBody.querySelector('.topCategory__groups')) {
      let fetched = false;
      const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      $btn.addEventListener('click', () => {
        if (fetched) return;
        fetched = true;
        fetch('/wp/wp-admin/admin-ajax.php?action=catalog_category_modal')
          .then((r) => r.json())
          .then((groups) => {
            if (!groups || !groups.length) return;
            const html = groups.map((group) => `
              <div class="topCategory__group">
                ${group.label ? `<p class="topCategory__groupTitle">${esc(group.label)}</p>` : ''}
                <div class="topCategoryGrid">
                  ${group.categories.map((cat) => `
                    <a href="${esc(cat.url)}" class="topCategoryCard">
                      <div class="topCategoryCard__icon">
                        ${cat.imgUrl
                          ? `<picture>${cat.imgWebp ? `<source srcset="${esc(cat.imgWebp)}" type="image/webp">` : ''}<img src="${esc(cat.imgUrl)}" alt="" loading="lazy" decoding="async"></picture>`
                          : '<span class="topCategoryCard__iconBlank"></span>'}
                      </div>
                      <p class="topCategoryCard__name">${esc(cat.name)}</p>
                    </a>`).join('')}
                </div>
              </div>`).join('');
            const $groups = document.createElement('div');
            $groups.className = 'topCategory__groups';
            $groups.innerHTML = html;
            $modalBody.appendChild($groups);
          })
          .catch(() => {});
      });
    }

  };


  /*
  *
  *  Header burger menu (SP)
  *
  */
  const initHeaderBurger = () => {
    const $burger = document.querySelector('.js--burger');
    const $drawer = document.getElementById('js--sp-drawer');

    if (!$burger || !$drawer) return;

    $burger.addEventListener('click', () => {
      const isOpen = $drawer.classList.toggle('is-open');
      $burger.classList.toggle('is-open', isOpen);
      $burger.setAttribute('aria-expanded', String(isOpen));
      $burger.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
      $drawer.setAttribute('aria-hidden', String(!isOpen));
    });
  }


  /*
  *
  *  initHeader
  *
  */
  // const $hbg = document.getElementById('js--menu-button'),
  //   $parentMenu = document.querySelectorAll('.common--header__nav-item:has(.common--header__navChild-list)'),
  //   $parentMenuArray = Array.from($parentMenu);


  // const initHeader = () => {
  //   judgeDeviceHeader();
  //   CATALOG.data.$window.addEventListener('onBreakpointChange', judgeDeviceHeader);
  // }

  // const judgeDeviceHeader = () => {
  //   if (CATALOG.data.$MQ === 'PC') {
  //     $hbg.removeEventListener('click', hbgClicked);
  //     $parentMenuArray.forEach(function (target) {
  //       target.removeEventListener('click', menuClicked);
  //     });
  //     headerClose();
  //     $parentMenuArray.forEach(function (target) {
  //       target.removeEventListener('click', menuClose);
  //     });

  //   } else { // TABLET SP
  //     $hbg.addEventListener('click', hbgClicked);

  //     $parentMenuArray.forEach(function (target) {
  //       target.addEventListener('click', menuClicked);
  //     });

  //   }
  // }

  // const hbgClicked = () => {
  //   if (CATALOG.data.$body.classList.contains('header--open')) {
  //     headerClose();
  //     screenUnLock();

  //   } else {
  //     headerOpen();

  //   }
  // }

  // const headerOpen = () => {
  //   CATALOG.data.$body.classList.add('header--open');
  //   screenLock();
  // }
  // const headerClose = () => {
  //   CATALOG.data.$body.classList.remove('header--open');
  // }

  // const menuClicked = (e) => {
  //   const $clickedMenu = e.currentTarget;

  //   if ($clickedMenu.classList.contains('is--open')) {
  //     menuClose($clickedMenu);

  //   } else {
  //     menuOpen($clickedMenu);

  //   }
  // }

  // const menuOpen = (menu) => {
  //   menu.classList.add('is--open');
  // }
  // const menuClose = (menu) => {
  //   menu.classList.remove('is--open');
  // }



  // ページごと読み込み event functions  ==========================================================

  /*
  *
  *
  *   ストレージ set・get
  *
  */
  // セッションストレージ - セット
  const setSessionStrage = (key, value) => {
    if (!window.sessionStorage) return;
    try {
      sessionStorage.setItem(key, value);
    } catch (err) { }
  }
  // ローカルストレージ - セット
  const setLocalStrage = (key, value) => {
    if (!window.localStorage) return;
    try {
      localStorage.setItem(key, value);
    } catch (err) { }
  }
  // セッションストレージ - ゲット
  const getSessionStrage = (targetStrage) => {
    var strage;
    if (!window.sessionStorage) return;
    try {
      strage = window.sessionStorage.getItem(targetStrage);
    } catch (err) {
    }
    return strage;
  }
  // ローカルストレージ - ゲット
  const getLocalStrage = (targetStrage) => {
    var strage;
    if (!window.localStorage) return;
    try {
      strage = window.localStorage.getItem(targetStrage);
    } catch (err) {
    }
    return strage;
  }



  /*
  *
  *   画像読み込み数カウンタ
  *   @target - jQueryオブジェクトで指定。指定された要素内のimgのロードを監視する。
  *   promiseを返すので、戻り値に対して.doneでコールバックを実装する。
  */
  const countImgLoaded = (target, runnninng) => {
    var deferred = new $.Deferred();

    var $img = (target) ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;

    $img.each(function () {
      var myImg = new Image();

      myImg.src = $(this).attr('src');

      myImg.onload = function () {
        count++;

        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }

        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });

    return deferred.promise();
  }



  const screenLock = () => {
    CATALOG.data.$html.classList.add('scrollLock');
    CATALOG.data.$body.classList.add('scrollLock');
    CATALOG.data.$body.setAttribute('data-scroll', CATALOG.data.scrollTop);

    CATALOG.data.$body.style.position = 'fixed';
    CATALOG.data.$body.style.top = -CATALOG.data.scrollTop + 'px';
  };
  const screenUnLock = () => {
    CATALOG.data.$html.classList.remove('scrollLock');
    CATALOG.data.$body.classList.remove('scrollLock');
    CATALOG.data.$body.removeAttribute('style');

    CATALOG.data.$window.scrollTo(0, CATALOG.data.$body.getAttribute('data-scroll'));
  };


  return {
    setSessionStrage,
    setLocalStrage,
    getSessionStrage,
    getLocalStrage,
    countImgLoaded,
    screenLock,
    screenUnLock,
    init
  };
}();